import { ConsentementEmail, Question } from '@amo/core/components/containers';
import { Text } from '@amo/core/components/forms';
import { postLogConsent } from '@amo/core/utils/requestsApi';
import { onError, validateEmail } from '@amo/core/utils/validateField';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { Field } from 'redux-form';

/**
 * Étape « Votre devis est presque prêt », juste après le tarif : e-mail du client (avec confirmation),
 * consentement relances / offres et consentement pixels / liens traçants. L'e-mail est repris sur « Vos infos ».
 */
const PreferencesEmail = (props) => {
    const { data, changeValue, postFill, loadingPostFill, token, canal, gestionnaireIsAMO } = props;
    const [afficheErreurPreferences, setAfficheErreurPreferences] = useState(false);

    const email = _.get(data, 'DemandeTarif[ListePersonnes][0][Email]');
    const emailValidation = _.get(data, 'EmailValidation');
    const emailContactConsent = _.get(data, 'DemandeDevis[EmailContactConsent]');
    const pixelConsent = _.get(data, 'DemandeDevis[PixelConsent]');
    const preferencesRenseignees =
        _.includes(['true', 'false'], emailContactConsent) && _.includes(['true', 'false'], pixelConsent);
    const emailsValides = Boolean(email) && !validateEmail(email) && email === emailValidation;

    useEffect(() => {
        changeValue('emailOnError', email && emailValidation && email !== emailValidation ? 'onError' : null);
    }, [email, emailValidation]);

    useEffect(() => {
        if (preferencesRenseignees) {
            setAfficheErreurPreferences(false);
        }
    }, [preferencesRenseignees]);

    const onClickNext = () => {
        if (!preferencesRenseignees) {
            setAfficheErreurPreferences(true);
        }
        if (!emailsValides || !preferencesRenseignees || loadingPostFill) {
            return;
        }

        // Le fill enregistre les consentements en session et passe à l'étape suivante
        postFill({ getTarif: false });

        const personne = data?.DemandeTarif?.ListePersonnes?.[0];
        // Le log écrase la ligne existante côté API : on renvoie le téléphone et son consentement déjà donnés
        postLogConsent({
            token,
            canal,
            phone: personne?.TelPortable ?? '',
            email: personne?.Email ?? '',
            phone_contact_consent: data?.DemandeDevis?.PhoneContactConsent,
            email_contact_consent: emailContactConsent,
            type: 'souscription',
        });
    };

    return (
        <Question loader title={'Votre devis est presque prêt'} subtitle={'Où souhaitez-vous le recevoir\u00a0?'} position={'top'}>
            <p className={'text-grey'}>
                Indiquez votre adresse e-mail pour recevoir votre devis et pouvoir le retrouver facilement.
            </p>

            <div className={'row justify-content-center'}>
                <div className={'col-lg-8 col-md-6 col-sm-6 col-12 my-2'}>
                    <Field
                        label={'Adresse e-mail'}
                        component={Text}
                        type={'email'}
                        typeFormat={'email'}
                        name={'DemandeTarif[ListePersonnes][0][Email]'}
                        placeholder={'prenom.nom@email.com'}
                        validate={validateEmail}
                        onChange={(e) => changeValue('DemandeContrat[SignatureEmail]', e.target.value)}
                        required
                        autocomplete="email"
                    />
                </div>
            </div>
            <div className={'row justify-content-center'}>
                <div className={'col-lg-8 col-md-6 col-sm-6 col-12 my-2'}>
                    <Field
                        label={'Confirmez votre adresse e-mail'}
                        component={Text}
                        type={'email'}
                        typeFormat={'email'}
                        name={'EmailValidation'}
                        placeholder={'Saisissez à nouveau votre adresse'}
                        validate={validateEmail}
                        required
                    />
                    <Field component={Text} name={'emailOnError'} type={'hidden'} validate={onError} />
                    {_.get(data, 'emailOnError') === 'onError' && (
                        <small className="alert alert-danger invalid-feedback d-block" role="alert">
                            Les deux adresses e-mail doivent être identiques.
                        </small>
                    )}
                    <small className={'text-start d-block text-grey mt-2'}>
                        Votre adresse est utilisée pour vous envoyer et retrouver votre devis.
                    </small>
                </div>
            </div>

            <div className={'row justify-content-center'}>
                <div className={'col-lg-8 col-12'}>
                    <ConsentementEmail className={'mt-4'} mandant={gestionnaireIsAMO ? 'aprilMoto' : 'amGestion'} />
                </div>
            </div>

            {afficheErreurPreferences && (
                <p className={'text-danger fw-bold f-14'} role={'alert'}>
                    Merci de renseigner vos préférences.
                </p>
            )}

            <button
                className={`btn btn-primary btn-arrow mt-4 ${!emailsValides || !preferencesRenseignees ? 'disabled' : ''}`}
                onClick={onClickNext}
            >
                {loadingPostFill ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                ) : (
                    'Continuer mon devis'
                )}
            </button>
        </Question>
    );
};

export default PreferencesEmail;
